import React, { useCallback, useEffect, useState } from 'react'
import { Modal, Button } from 'antd'
import { TranslationKeys } from '../../Constants/TranslationKeys'
import { renderTranslation } from '../../Helpers/GenericHelpers'
import { useAppDispatch, useAppSelector } from '../../hooks'

function DescriptionModal(props) {
  const dispatch = useAppDispatch()
  const language = useAppSelector(state => state.present.language.value)
  const [openModal, setOpenModal] = useState(false)

  useEffect(() => {
    setOpenModal(props.errors.length > 0)
  }, [props.errors])

  return (
    <Modal
      title={renderTranslation(language, TranslationKeys.checkerrors)}
      open={openModal}
      closable={false}
      width={400}
      footer={null}
      className={'confirm-change-modal'}
      getContainer={props.bodyref?.current}
    >
      <div className='modal-body-text modaldescription '>
        {' '}
        {props.errors
          ?.sort((a, b) => a.set.localeCompare(b.set))
          .map((err, index) => {
            return (
              <div>
                <p>{err.error}</p>
              </div>
            )
          })}
      </div>
      <div className='modal-body-btn-box'>
        <Button
          className='btn confirm-btn'
          onClick={e => {
            setOpenModal(false)
          }}
        >
          OK
        </Button>
      </div>
    </Modal>
  )
}

export default DescriptionModal
